export default "__VITE_ASSET__Ci40pMNM__"